<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    transition="dialog-bottom-transition"
    @click:outside="close"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="overflowBtn"
        elevation="6"
        :color="partnerColor.primary"
        fab
        fixed
        bottom
        right
        v-bind="attrs"
        v-on="on"
        ><v-icon color="white"> mdi-plus </v-icon>
      </v-btn>
      <v-btn
        class="d-none d-sm-block ml-2"
        dense
        small
        depressed
        :color="partnerColor.primaryDarken_2"
        dark
        v-bind="attrs"
        v-on="on"
      >
        {{ $t("components.thg.ThgMeterReadingForm.btnText") }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title :style="partnerColor.gradientStyle">
        <span :style="`color:white`"> {{ $t("components.thg.ThgMeterReadingForm.btnTextAlt") }}</span>
        <v-spacer />
        <v-btn :color="partnerColor.primaryDarken_3" icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <thg-meter-reading-form
          ref="form"
          :chargingStationId="chargingStationId"
          @save="save"
          :isSaving="loading"
        ></thg-meter-reading-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import ThgMeterReadingForm from "@/components/thg/ThgMeterReadingForm.vue";
import { HttpException } from "@/lib/exceptions/http";
import { PartnerColor } from "@/lib/partnerColor";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { CreateMeterReading } from "@/store/models/thg/meter-reading";
import { MeterReadingModule } from "@/store/modules/meter-reading.store";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: { ThgMeterReadingForm }
})
export default class ThgChargingStationMeterReadingFormDialog extends DarkModeHighlightMixin {
  @Prop({ default: false })
  overflowBtn!: boolean;

  chargingStationId = this.$route.params.chargingStationId;

  dialog = false;
  loading = false;

  async save(data: CreateMeterReading) {
    const partnerId = PartnerModule.partner.id || PartnerModule.partner._id;
    this.$log.debug(data);
    try {
      this.loading = true;
      await MeterReadingModule.createMeterReading({ partnerId, data });
      await MeterReadingModule.getMeterReadingsByChargingStation(this.$route.params.chargingStationId);
      this.$toast.success(this.$t("report.thgMeterReadingCreate.success"));
    } catch (error) {
      this.$log.error(error);
      if (error instanceof HttpException) {
        this.$toast.error(error.message);
      }
    } finally {
      this.loading = false;
    }
    this.close();
  }

  openDialog() {
    this.dialog = true;
  }

  close() {
    (this.$refs.form as ThgMeterReadingForm).resetForm();
    this.dialog = false;
  }

  partnerColor = new PartnerColor();
}
</script>
